// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonCreateLabel {
  display: flex;
  font-size: 1.26rem;
}

.countrycode-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller {
  max-height: 870px;
  overflow-y: scroll;
  width: 100%;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.commonCreateButton {
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.commonTextLabel {
  display: flex;
}

.actionSection {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSection .commonActionItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 15px 0px 15px;
}

.refextSection {
  display: flex;
}

.refTextField {
  display: flex;
  flex: 0 0 100%;
  align-content: center;
}

.setDisplay {
  display: flex;
}
.setDisplay .refFieldDiv, .setDisplay .currencyDiv {
  display: flex;
  flex: 1 0 45%;
  padding-right: 5px;
}
.setDisplay .custRefFieldDiv, .setDisplay .invoicedateDiv {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.typeDiv {
  display: flex;
  flex: 1 0 45%;
  padding-right: 5px;
}

.textAreaDiv {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.actionSectionRight {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSectionRight .commonActionItem {
  display: grid;
}

.commonactionRight {
  display: flex;
  flex: 1 0 50%;
}

.searchInvoiceDiv {
  display: flex;
  flex: 1 0 50%;
  justify-content: flex-end;
}

.setMarginLeft {
  margin-left: 25px;
}

.footerSectionArea {
  display: flex;
}

.footerFieldDiv {
  display: flex;
  flex: 0 0 60%;
}

.amountDivSection {
  display: flex;
  flex: 0 0 40%;
  justify-content: space-between;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.css-pk82a1-MuiFormHelperText-root {
  font-size: 11px !important;
  margin-left: 1px !important;
}

.leftSection {
  padding: 5px 15px;
  border-radius: 5px;
  margin-top: 10px;
  height: 725px;
}`, "",{"version":3,"sources":["webpack://./src/features/module/module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AACE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,mCAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,aAAA;AAGJ;;AAEA;EACI,aAAA;EACA,wBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AACR;;AAEA;EACI,aAAA;AACJ;;AACA;EACI,aAAA;EACA,cAAA;EACA,qBAAA;AAEJ;;AAAA;EACI,aAAA;AAGJ;AAFI;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAIR;AAFI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAIR;;AADA;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,aAAA;EACA,wBAAA;AAMJ;AALI;EACI,aAAA;AAOR;;AAAA;EACI,aAAA;EACA,aAAA;AAGJ;;AADA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,iBAAA;AAKJ;;AAFA;EACI,aAAA;AAKJ;;AAHA;EACI,aAAA;EACA,aAAA;AAMJ;;AAJA;EACI,aAAA;EACA,aAAA;EACA,8BAAA;AAOJ;;AAJA;EACI,wBAAA;AAOJ;;AALE;EACE,gCAAA;EACA,mCAAA;AAQJ;;AANG;EACC,0BAAA;EACA,2BAAA;AASJ;;AAPE;EACE,iBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,aAAA;AASJ","sourcesContent":[".commonCreateLabel {\n    display: flex;\n    font-size: 1.26rem;\n}\n\n.countrycode-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n  .MuiDataGrid-virtualScroller {\n    max-height: 870px;\n    overflow-y: scroll;\n    width: 100%;\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n  }\n\n.commonCreateButton{\n    display:flex;\n    align-items:center;\n    margin-left: 5px;\n}\n.commonTextLabel {\n    display: flex;\n    // font-size: 1rem;\n    // align-items: center;\n}\n\n.actionSection{\n    display: flex;\n    margin: 0px 10px 0px 0px;\n    // justify-content: space-between;\n    .commonActionItem{\n        display: flex;    \n        flex-direction: column;\n        align-items: center;\n        padding: 0px 15px 0px 15px;\n    }\n}\n.refextSection{\n    display: flex;\n}\n.refTextField{\n    display: flex;\n    flex: 0 0 100%;  \n    align-content: center; \n}\n.setDisplay{\n    display: flex;\n    .refFieldDiv,.currencyDiv{\n        display: flex;\n        flex: 1 0 45%;\n        padding-right: 5px;\n    }\n    .custRefFieldDiv,.invoicedateDiv{\n        display: flex;\n        flex: 1 0 45%;\n        padding-left: 5px;\n    }\n}\n.typeDiv{\n    display: flex;\n    flex: 1 0 45%;\n    padding-right: 5px;\n}\n.textAreaDiv{\n    display: flex;\n    flex: 1 0 45%;\n    padding-left: 5px;\n}\n.actionSectionRight{\n    display: flex;\n    margin: 0px 10px 0px 0px; \n    .commonActionItem{\n        display: grid;\n        // display: flex;    \n        // flex-direction: column;\n        // align-items: center;\n        // padding: 0px 15px 0px 15px;\n    }\n}\n.commonactionRight{\n    display: flex;\n    flex: 1 0 50%;\n}\n.searchInvoiceDiv{\n    display: flex;\n    flex: 1 0 50%;\n    justify-content: flex-end;\n}\n.setMarginLeft{\n    margin-left: 25px;\n}\n\n.footerSectionArea{\n    display: flex;\n}\n.footerFieldDiv{\n    display: flex;\n    flex: 0 0 60%;\n}\n.amountDivSection{\n    display:flex;\n    flex: 0 0 40%;\n    justify-content: space-between;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n  .MuiDataGrid-virtualScroller {\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n  }\n   .css-pk82a1-MuiFormHelperText-root{\n    font-size: 11px !important;\n    margin-left: 1px !important;\n  }\n  .leftSection{\n    padding: 5px 15px;\n    // border: 1px solid #333!important;\n    border-radius: 5px;\n    margin-top: 10px;\n    height: 725px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
